import styled from '@emotion/styled';

interface Props {
  fontSize?: string;
  fontWeight?: string;
  color?: string;
  textAlign?: string;
}

const Text = styled.span<Props>`
  font-size: ${({ fontSize }) => fontSize || '16px'};
  font-weight: ${({ fontWeight }) => fontWeight || 'normal'};
  color: ${({ color }) => color || 'inherit'};
  text-align: ${({ textAlign }) => textAlign || 'left'};
`;

export default Text;
